import ReactController from '~/controllers/react_controller'
import AWSS3DashboardCharts from '~/dashboard/aws_s3_dashboard_charts'

export default class AWSS3DashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
  }

  createComponent() {
    return <AWSS3DashboardCharts organizationId={this.organizationIdValue} />
  }
}
